import logo from '../../images/notflix.png';
import classes from './NotflixLogo.module.css';

const NotflixLogo = props => {
    return (
            <img
                src={logo}
                alt='Logo'
                style={props.style}
                className={classes.logo}
            >
            </img>
    )
}

export default NotflixLogo;
